<template>
<div>
  <div class="columns">
    <div class="column">
      <div class="columns">
        <div class="column">
          <h3 class="is-size-3">
            {{ vulnerability.cvid }}
          </h3>
          <p>Published {{ vulnerability.published_at | asCalendar }}</p>
        </div>
        <div class="column is-narrow">
          <div class="score-box is-danger">
            <span class="severity">{{ vulnerability.severity }}</span>
            <span class="score">{{ vulnerability.cvss }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="columns">
            <div class="column">
              <p class="has-text-weight-bold">
                Summary of Vulnerability
              </p>
              <p>
                {{ vulnerability.description }}
              </p>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <p class="has-text-weight-bold">Recommendation</p>
              <p>{{ finding.poc.recommendation }}</p>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <p class="has-text-weight-bold">References</p>
          <p v-for="(reference, index) in vulnerability.references" :key="index">
            <a :href="reference.url" target="_blank">{{ reference.name | truncate(30) }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  props: {
    vulnerability: {
      type: Object,
      default: () => ({
        poc: {}
      })
    }
  },

  computed: {
    ...mapGetters('finding', [
      'finding'
    ])
  }

}
</script>